import { ActionIcon, type ActionIconProps } from '@mantine/core';
import type { CSSProperties, ReactNode } from 'react';

type Props = Omit<ActionIconProps, 'variant' | 'style' | 'radius'> & {
  diameter: number;
  radius: number;
  onClick?: () => void;
  'aria-label': string;
  'data-testid'?: string;
  style?: CSSProperties;
  children: ReactNode;
};

// Gray rounded-square icon button used across the individual-details rework (back button, section
// edit pencil). `radius` is applied inline because the theme's `.actionIconRoot` class forces an
// 8px border-radius that overrides the Mantine `radius` prop.
export function SquareIconButton({ diameter, radius, style, children, ...props }: Props) {
  return (
    <ActionIcon
      variant="subtle"
      color="gray"
      w={diameter}
      h={diameter}
      bg="gray.1"
      style={{ borderRadius: radius, ...style }}
      {...props}
    >
      {children}
    </ActionIcon>
  );
}
